<template>
  <IllustratedSection
    :has-horizontal-margin="false"
    illustration="rich-inbox-empty"
    outlined
    smaller-headline-spacing
  >
    <template #headline>{{ $t('richinbox.empty.headline') }}</template>
    <template #subtitle>{{ $t('richinbox.empty.description') }}</template>
  </IllustratedSection>
</template>
